/*
 * @Description: 路由
 * @Date: 2025-05-26 18:10:43
 */
export const route = [
  {
    path: '/main/submit-task-list',
    name: 'submit-task-list',
    meta: {
      title: '提交任务'
    },
    component: () => import('../views/submit-task-list/index')
  }
];
